import BaseEntity from '@/models/base/BaseEntity.model';

export default class ReclamoModel extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public descripcion: string;
    public telefonoReclamo: string;
	public tarjetaReclamo: string;
	public tarjeta: string;
	public descripcionReemplazo: string;
	public correo: string;
	public ocupacion: string;
	public fechatarjeta: string;
	public descripcionReclamo: string;
    constructor() {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.descripcion = '';
        this.telefonoReclamo = '';
		this.tarjetaReclamo = '';
		this.descripcionReemplazo = '';
		this.correo = '';
		this.ocupacion = '';
		this.fechatarjeta = '';
		this.tarjeta = '';
		this.descripcionReclamo ='';
    }
}